import { post, put, get, del } from "../fetch.v2"
import { IEvent, IEventCreate } from "../../interfaces/event"
import { getDomainId } from "../../utils/store"

class EventApi {
  url: string

  constructor(domainId?: number) {
    this.url = `/domains/${domainId || getDomainId()}/events`
  }

  async getById(eventId: number) {
    return get(`${this.url}/${eventId}`)
  }

  async getAll() {
    return get(this.url)
  }

  async create(event: IEventCreate) {
    await post(`${this.url}`, event)
    return this
  }

  async delete(id: number) {
    await del(`${this.url}/${id}`)
    return this
  }

  async updateOne(id: number, event: Partial<IEvent>) {
    await put(`${this.url}/${id}`, event)
    return this
  }
}

export default EventApi
